import { Table } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  overflow-x: auto;

  .activity-cell{
    max-width: 250px;
    overflow: hidden;
  }

  .ant-table-cell {
    text-align: left;
  }
  .ant-table-thead > tr > th {
    background-color: #dbebff;
    font-weight: bold;
    text-align: left;
    border-right: none !important;
  }

   .ant-table-row .ant-table-row-expand-icon-cell {
  display: none !important;
}

 .ant-table-row-expand-icon-cell{
  display: none;
}


  .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table{
    margin-block: 0;
  }

  .ant-table-tbody >tr >td {
    white-space: nowrap;
  }
`;